import React from 'react'
import { Table } from 'antd'

export default function MyTable(props) {
  return <Table size="small" scroll={{ x: true }} {...props} />
}
